<!-- Regular seller layout with defer -->
@if(!!entityData() && !isAutonomousSeller) {
  @defer (when !!entityData()) {
    <app-standard-seller [sellerData]="entityData()" />
  }
}

<!-- Autonomous seller layout with defer -->
@if(!!entityData() && isAutonomousSeller) {
  @defer (when !!entityData()) {
    <app-autonomous-seller-detail [sellerData]="entityData()" />
  }
}
